import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad14BBlue22CBlue = () => <CrossRoad coords="2314.366149, 1213.568902"/>;
export default CrossRoad14BBlue22CBlue;
